export default (appealLength) => [
  {
    icon: require('@/assets/new/icon_dashboard.svg?external'),
    text: 'dashboard',
    key: 'Dashboard',
    routeName: 'Dashboard',
    show: 'true',
    amount: 0,
  },
  {
    icon: require('@/assets/new/icon_pillars.svg?external'),
    text: 'pillars',
    key: 'Pillars',
    routeName: 'Pillars',
    show: 'true',
    amount: 0,
  },
  {
    icon: require('@/assets/new/icon_appeal.svg?external'),
    text: 'forms',
    key: 'Forms',
    routeName: 'Dealer-Forms',
    show: 'true',
    amount: appealLength,
  },
  {
    icon: require('@/assets/new/icon_archive.svg?external'),
    text: 'archive',
    key: 'Archive',
    routeName: 'Archive',
    show: 'true',
    amount: 0,
  },
  {
    icon: require('@/assets/new/icon_documents.svg?external'),
    text: 'Survey Interference',
    key: 'DealerSI',
    routeName: 'DealerSI',
    show: 'true',
    amount: 0,
  },
];
